export default {
  activate() {},
  deactivate() {},
};
